// extracted by mini-css-extract-plugin
export default {"GenericDialog":"GenericDialog_GenericDialog__9jHMQ","contentModalBtn":"GenericDialog_contentModalBtn__+AwTR"};